var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { getProductConfig } from "@rendering/vortex-product-loader";
import { useState, useEffect } from "react";
const getProductConfigByUrl = url => __awaiter(void 0, void 0, void 0, function* () {
  const response = yield fetch(url);
  return yield response.json();
});
const resolveProductConfig = _a => __awaiter(void 0, [_a], void 0, function (_ref) {
  let {
    productConfig
  } = _ref;
  return function* () {
    if (typeof productConfig === "string") {
      return getProductConfigByUrl(productConfig);
    }
    if (productConfig.sku) {
      return getProductConfig(productConfig);
    }
    return productConfig;
  }();
});
export function useProductConfigResolver(productConfig, onError) {
  const [resolvedProductConfig, setResolvedProductConfig] = useState();
  useEffect(() => {
    let ignore = false;
    resolveProductConfig({
      productConfig
    }).then(vortexProductConfig => {
      if (!ignore) {
        setResolvedProductConfig({
          source: productConfig,
          resolved: vortexProductConfig
        });
      }
    }).catch(error => {
      if (!ignore) {
        setResolvedProductConfig({
          source: productConfig,
          error
        });
        onError(error);
      }
    });
    return () => {
      ignore = true;
    };
  }, [productConfig, onError]);
  if ((resolvedProductConfig === null || resolvedProductConfig === void 0 ? void 0 : resolvedProductConfig.source) === productConfig) {
    return {
      resolved: resolvedProductConfig.resolved,
      error: resolvedProductConfig.error
    };
  }
  return undefined;
}